import { render, staticRenderFns } from "./feedBack.html?vue&type=template&id=9669fc8e&"
import script from "./feedBack.ts?vue&type=script&lang=ts&"
export * from "./feedBack.ts?vue&type=script&lang=ts&"
import style0 from "./feedBack.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports